module.exports = __webpack_public_path__ + "static/media/Water.ce92732a.png";